/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Helper_TextInputs */

const en_wallet_card_helper_text = /** @type {(inputs: Wallet_Card_Helper_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Present this card to any emergency assistance staff, claims administrator, or medical administrator in the event of an emergency on your trip.`)
};

const fr_wallet_card_helper_text = /** @type {(inputs: Wallet_Card_Helper_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Présentez cette carte à tout personnel d'assistance d'urgence, administrateur de réclamations ou administrateur médical en cas d'urgence lors de votre voyage.`)
};

/**
* | output |
* | --- |
* | "Present this card to any emergency assistance staff, claims administrator, or medical administrator in the event of an emergency on your trip." |
*
* @param {Wallet_Card_Helper_TextInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_helper_text = /** @type {((inputs?: Wallet_Card_Helper_TextInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Helper_TextInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_helper_text(inputs)
	return fr_wallet_card_helper_text(inputs)
});